import React from 'react';
import ChartTogglebar from './ChartTogglebar';
import { Grid } from '@material-ui/core';
import AboutTogglebar from './AboutTogglebar';
import ChartView from './ChartView';
import useStyles from './Styles';

const ArizonaView = () => {
    const classes = useStyles();
    return (
        <Grid container item className={classes.mainView}>
            <ChartTogglebar />
            <ChartView />
            <AboutTogglebar />
        </Grid>
    );
};

export default ArizonaView;

